"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATIC_PARTIAL_MYID_USERS = void 0;
const user_1 = require("../user");
const _STATIC_PARTIAL_MYID_USERS = [
    {
        given_name: 'Masha',
        family_name: 'Dowell',
        'relationship.employeeId': 'DOWEM015',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Andrea',
        family_name: 'Trevino',
        'relationship.employeeId': 'TREVA025',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Jamie',
        family_name: 'Park',
        'relationship.employeeId': 'PARKJ297',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Kristen',
        family_name: 'Batko',
        'relationship.employeeId': 'BATKK002',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Alejandra',
        family_name: 'Sabogal',
        'relationship.employeeId': 'SABOJ012',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER, user_1.ROLE_QA],
    },
    {
        given_name: 'Erik',
        family_name: 'Avellaneda',
        'relationship.employeeId': 'AVELE004',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Colleen',
        family_name: 'Watson',
        'relationship.employeeId': 'WATSC079',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Karisa',
        family_name: 'Bruin',
        'relationship.employeeId': 'BRUIK002',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Sean',
        family_name: 'Costello',
        'relationship.employeeId': 'COSTS046',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Kris',
        family_name: 'Miranda',
        'relationship.employeeId': 'MIRAK021',
        roles: [user_1.ROLE_QA, user_1.ROLE_DEI],
    },
    {
        given_name: 'Sean',
        family_name: 'Persaud',
        'relationship.employeeId': 'PERSS019',
        roles: [user_1.ROLE_QA],
    },
    {
        given_name: 'Courteney',
        family_name: 'Merritt',
        'relationship.employeeId': 'MERRC033',
        roles: [user_1.ROLE_ADMIN],
    },
    {
        given_name: 'Melina',
        family_name: 'Ovanessian',
        'relationship.employeeId': 'OVANM001',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Mara',
        family_name: 'Lucien',
        'relationship.employeeId': 'SCHMM059',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Evan',
        family_name: 'Golden',
        'relationship.employeeId': 'GOLDE043',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Nicole',
        family_name: 'Uchimura',
        'relationship.employeeId': 'UCHIN002',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Scott',
        family_name: 'Morehead',
        'relationship.employeeId': 'MORES103',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_QA],
    },
    {
        given_name: 'Alex',
        family_name: 'Niedt',
        'relationship.employeeId': 'NIEDA009',
        roles: [user_1.ROLE_ADMIN, user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Lori',
        family_name: 'Huck',
        'relationship.employeeId': 'HUCKL005',
        roles: [user_1.ROLE_QA, user_1.ROLE_DEI],
    },
    {
        given_name: 'Melissa',
        family_name: 'Mirch',
        'relationship.employeeId': 'MIRCM003',
        roles: [user_1.ROLE_QA, user_1.ROLE_DEI],
    },
    {
        given_name: 'Sonya',
        family_name: 'Ellis',
        'relationship.employeeId': 'ELLIS108',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Marchae',
        family_name: 'Miller',
        'relationship.employeeId': 'MILLM501',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Andrew',
        family_name: 'Viera',
        'relationship.employeeId': 'VIERA021',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Johanna',
        family_name: 'Evans',
        'relationship.employeeId': 'EVANJ157',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Nicole',
        family_name: 'Hall',
        'relationship.employeeId': 'HALLN044',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Ada',
        family_name: 'Douglass',
        'relationship.employeeId': 'DOUGA073',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Evan',
        family_name: 'Marshall',
        'relationship.employeeId': 'MARSE041',
        roles: [user_1.ROLE_TAGGER],
    },
    {
        given_name: 'Sinead',
        family_name: 'Persaud',
        'relationship.employeeId': 'PERSS020',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_DEI],
    },
    {
        given_name: 'Ivan',
        family_name: 'Tanev',
        'relationship.employeeId': 'TANEI001',
        roles: [user_1.ROLE_ADMIN],
    },
    {
        given_name: 'David',
        family_name: 'Pean',
        'relationship.employeeId': 'PEAND001',
        roles: [user_1.ROLE_ADMIN],
    },
    {
        given_name: 'Anna',
        family_name: 'Rybakov',
        'relationship.employeeId': 'RYBAA003',
        roles: [user_1.ROLE_QA, user_1.ROLE_DEI],
    },
    {
        given_name: 'Isabel',
        family_name: 'Cava',
        'relationship.employeeId': 'CAVAI007',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_QA],
    },
    {
        given_name: 'Christian',
        family_name: 'Sanchez',
        'relationship.employeeId': 'SANCC259',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_QA],
    },
    {
        given_name: 'Igor',
        family_name: 'Mishurin',
        'relationship.employeeId': 'MISHI003',
        roles: [user_1.ROLE_TAGGER, user_1.ROLE_QA],
    },
];
_STATIC_PARTIAL_MYID_USERS.sort((a, b) => {
    const nameA = `${a.given_name} ${a.family_name}`;
    const nameB = `${b.given_name} ${b.family_name}`;
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
});
exports.STATIC_PARTIAL_MYID_USERS = _STATIC_PARTIAL_MYID_USERS;
//# sourceMappingURL=static-partial-myid-users.js.map